import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import { createSelector } from 'reselect';
import { orderBy } from 'lodash';

const options = {
  name: 'standbyDutyFunctions',
  baseType: 'STANDBY_DUTY_FUNCTIONS',
  apiEndpoint: 'standby_duty_functions'
};

const operations = createMetadataAPIOperations(options);
const defaultSelectors = createMetadataAPISelectors(options);

const active = createSelector(defaultSelectors.values, functions =>
  orderBy(
    functions.filter(e => e.active),
    'display_order'
  )
);

const selectors = {
  ...defaultSelectors,
  active
};

export { operations, selectors };
export default createMetadataAPIReducer(options);
